import { z } from 'zod';

import { type SelectFieldOption } from '@hrlogics/react-helper-types';

export const selectFieldOptionValidationSchema = z.object({
  label: z.string(),
  value: z.string(),
}) satisfies z.ZodType<SelectFieldOption>;
